export default "__VITE_ASSET__StGPh7um__"